"use client";

import { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";

export default function BlogEditor({ value, onChange }) {
  const editorRef = useRef(null);

  return (
    <div className="w-full border border-gray-200 rounded-lg overflow-hidden">
      <Editor
        // Puedes conseguir una API key gratuita en tinymce.com.
        // Si no la pones, funcionará pero mostrará un aviso de advertencia.
        // apiKey="TU_API_KEY_AQUI_O_DEJALO_VACIO_PARA_PROBAR"
        tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/6.8.3/tinymce.min.js"
        onInit={(evt, editor) => (editorRef.current = editor)}
        value={value}
        onEditorChange={(content) => onChange(content)}
        init={{
          height: 600,
          menubar: false,
          language: "es", // Para que la interfaz esté en español
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks | " +
            "bold italic forecolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "table | removeformat | help",

          // --- CONFIGURACIÓN CLAVE PARA WORD ---
          paste_as_text: false, // DEBE ser false para que respete las tablas al pegar
          paste_data_images: true, // Permite pegar imágenes directamente

          // Estilos base para que el editor se parezca a Tailwind 'prose'
          content_style: `
            body { 
              font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; 
              font-size: 16px; 
              line-height: 1.6; 
              color: #374151; 
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
            }
            table, th, td { 
              border: 1px solid #e5e7eb; 
            }
            th, td { 
              padding: 12px; 
              text-align: left; 
            }
            th { 
              background-color: #f9fafb; 
              font-weight: 600; 
            }
          `,
        }}
      />
    </div>
  );
}
